import firebase from 'firebase';
import { useAtom } from 'jotai';
import { useCollectionData } from 'react-firebase-hooks/firestore';
// state
import { userRecordAtom } from '../../../../shared/state/atoms';
// constants
import { FIRESTORE_KEYS } from '../../../../shared/utils/constants';

export default function useParentList() {
  const [user] = useAtom(userRecordAtom);

  const [parentList] = useCollectionData(
    firebase
      .firestore()
      .collection(FIRESTORE_KEYS.PARENTS)
      .where('schoolIds', 'array-contains', user?.school?.id || ''),
    { idField: 'id' }
  );

  return { parentList };
}
